import * as React from 'react';
import { JSX } from 'react/jsx-runtime';
interface BusPickupAllocationIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}
const LightSunIcon: React.FC<BusPickupAllocationIconProps> = ({
  color,
  ...props
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1481_44852)">
      <path
        d="M10 5.75C7.65625 5.75 5.75 7.65625 5.75 10C5.75 12.3438 7.65625 14.25 10 14.25C12.3438 14.25 14.25 12.3438 14.25 10C14.25 7.65625 12.3438 5.75 10 5.75ZM10 12.8437C8.4375 12.8437 7.15625 11.5625 7.15625 10C7.15625 8.4375 8.4375 7.15625 10 7.15625C11.5625 7.15625 12.8437 8.4375 12.8437 10C12.8437 11.5625 11.5625 12.8437 10 12.8437Z"
        fill="#637381"
      />
      <path
        d="M10 3.53125C10.375 3.53125 10.7187 3.21875 10.7187 2.8125V1.25C10.7187 0.875 10.4063 0.53125 10 0.53125C9.625 0.53125 9.28125 0.84375 9.28125 1.25V2.84375C9.3125 3.21875 9.625 3.53125 10 3.53125Z"
        fill="#637381"
      />
      <path
        d="M10 16.4688C9.625 16.4688 9.28125 16.7812 9.28125 17.1875V18.75C9.28125 19.125 9.59375 19.4688 10 19.4688C10.375 19.4688 10.7187 19.1563 10.7187 18.75V17.1563C10.7187 16.7813 10.375 16.4688 10 16.4688Z"
        fill="#637381"
      />
      <path
        d="M15.0937 5.625C15.2812 5.625 15.4688 5.5625 15.5938 5.40625L16.5937 4.40625C16.875 4.125 16.875 3.6875 16.5937 3.40625C16.3125 3.125 15.875 3.125 15.5938 3.40625L14.5937 4.40625C14.3125 4.6875 14.3125 5.125 14.5937 5.40625C14.7187 5.5625 14.9062 5.625 15.0937 5.625Z"
        fill="#637381"
      />
      <path
        d="M4.4375 14.59L3.4375 15.5588C3.15625 15.84 3.15625 16.2775 3.4375 16.5588C3.5625 16.6838 3.75 16.7775 3.9375 16.7775C4.125 16.7775 4.3125 16.715 4.4375 16.5588L5.4375 15.5588C5.71875 15.2775 5.71875 14.84 5.4375 14.5588C5.15625 14.3088 4.6875 14.3088 4.4375 14.59Z"
        fill="#637381"
      />
      <path
        d="M18.75 9.3125H17.1563C16.7813 9.3125 16.4375 9.625 16.4375 10.0312C16.4375 10.4062 16.75 10.75 17.1563 10.75H18.75C19.125 10.75 19.4688 10.4375 19.4688 10.0312C19.4688 9.625 19.125 9.3125 18.75 9.3125Z"
        fill="#637381"
      />
      <path
        d="M3.53125 10C3.53125 9.625 3.21875 9.28125 2.8125 9.28125H1.25C0.875 9.28125 0.53125 9.59375 0.53125 10C0.53125 10.375 0.84375 10.7187 1.25 10.7187H2.84375C3.21875 10.7187 3.53125 10.375 3.53125 10Z"
        fill="#637381"
      />
      <path
        d="M15.5625 14.5937C15.2813 14.3125 14.8438 14.3125 14.5625 14.5937C14.2812 14.875 14.2812 15.3125 14.5625 15.5938L15.5625 16.5937C15.6875 16.7187 15.875 16.8125 16.0625 16.8125C16.25 16.8125 16.4375 16.75 16.5625 16.5937C16.8438 16.3125 16.8438 15.875 16.5625 15.5938L15.5625 14.5937Z"
        fill="#637381"
      />
      <path
        d="M4.4375 3.4375C4.15625 3.15625 3.71875 3.15625 3.4375 3.4375C3.15625 3.71875 3.15625 4.15625 3.4375 4.4375L4.4375 5.4375C4.5625 5.5625 4.75 5.65625 4.9375 5.65625C5.125 5.65625 5.3125 5.59375 5.4375 5.4375C5.71875 5.15625 5.71875 4.71875 5.4375 4.4375L4.4375 3.4375Z"
        fill="#637381"
      />
    </g>
    <defs>
      <clipPath id="clip0_1481_44852">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default LightSunIcon;
